import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../../assets/css/App.css';
import { max } from 'moment';
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class LDIntro extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
                <div>
                  <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub3']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub3" title={<span><Icon type="user" />Lipiodol</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation">Evaluation</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />Prediction</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation">Calculation</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <div>
                            <Content style={{ marginLeft: 50, background: '#dcefef' }}>
                                <div style={{ marginLeft: 100, paddingTop:30, width: 600, height: 1000, background: '#dcefef' }}>
                                <txt style={{fontSize:20,marginTop:50,}}>
                                <txt style={{fontSize:22,fontWeight:'bold'}}>Welcome to visit the module of the refined biomarker of lipiodol deposition (LD) of TACE for hepatocellular carcinoma (HCC) patients.</txt> 
                                <br/><br/>Evaluation of LD one month after TACE is most commonly used biomarker for efficacy assessment, which provides a reference for subsequent treatment. This biomarker is the primary reference for embolization of target tumor regions, and previous studies have confirmed that its quantitative evaluation provides a valid foundation for subsequent treatment decisions and development of follow-up plans. However, current classification methods of postoperative LD, such as deposition morphology, deposition ratio, deposition pattern, and necrosis, are non-uniform, and each method only considers a portion of the important aspects.
                                <br/><br/>To address these challenges, we conducted a comprehensive review of the published postoperative classification methods of LD one month after TACE. By identifying the merits of each classification method and reviewing the prognoses of each sub-category, we were able to propose a refined definiton of postoperative LD. The factors of LD percentage, pattern, distribution, and tumor necrosis were used as independent variables to construct the new approach, and the synergetic effects of all the four factors on survival was quantitatively integrated into an exponential model for stratification of LD.
                                
                                </txt>
                                </div>
                            </Content>
                        </div>

                        <div>
                            <Content style={{ background: '#dcefef' }}>
                                <div style={{ marginLeft: 120, paddingTop:30,paddingRight:100, width: 700, height: 1000, background: '#dcefef' }}>
                                
                                <txt style={{fontSize:28,fontWeight:'bold',}}>
                                INSTRUCTIONS
                                </txt>
                        
                                <txt style={{fontSize:20}}>
                                <br/><br/>Click on the <txt style={{fontSize:22,fontWeight:'bold'}}>Evaluation</txt> button on the navigation page, and type in the parameters. The calculator will generate the result of estimation of median time to progression, and the cumulative 1-, 2-, and 3-year progression-free rates.
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;y=e^(-Dr×Cp×Nc×Up×b)</txt>

                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Dr</txt> represents LD percentage (classified into the following four subgroups: 100%, 85%–99%, 35%–85%, and &#60;35%).
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Cp</txt> indicates whether the deposition is compact or not. 
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Nc</txt> represents necrosis (classified into the following three subgroups: 100%, 50%–99%, and &#60;50%).
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Up</txt> represents nodule uptake pattern (classified into the following three subgroups: nodule uptake pattern [NU], multinodular lipiodol uptake in diffuse pattern [MNU], all other possibilities).
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>b</txt> is a reserved variable to facilitate the addition of new risk factor(s) in future studies.
                                    </txt>
   
                                </div>
                            </Content>
                        </div>
              </Layout>
            </Content>
            </div>
        )
    }
}
export default LDIntro;